export const SUPPORTED_SYMBOL_FILE_EXTENSIONS = ['svg', 'png'] as const;
export type SupportedSymbolFileExtension = (typeof SUPPORTED_SYMBOL_FILE_EXTENSIONS)[number];

export const SUPPORTED_SYMBOL_MIME_TYPES = ['image/svg+xml', 'image/png'] as const;
export type SupportedSymbolMimeType = (typeof SUPPORTED_SYMBOL_MIME_TYPES)[number];

export function isSupportedSymbolMimeType(value: string): value is SupportedSymbolMimeType {
  return SUPPORTED_SYMBOL_MIME_TYPES.includes(value as SupportedSymbolMimeType);
}

export function isSupportedSymbolFileExtension(value: string): value is SupportedSymbolFileExtension {
  return SUPPORTED_SYMBOL_FILE_EXTENSIONS.includes(value as SupportedSymbolFileExtension);
}

export function extractSymbolFileExtension(fileName: string): SupportedSymbolFileExtension | undefined {
  const extension = fileName.split('.').pop()?.toLowerCase();
  if (!extension) {
    return undefined;
  }

  if (isSupportedSymbolFileExtension(extension)) {
    return extension;
  }

  return undefined;
}

export type SupportedSymbolFileSuffix = `.${SupportedSymbolFileExtension}`;

export function toSymbolFileSuffix(extension: SupportedSymbolFileExtension): SupportedSymbolFileSuffix {
  return `.${extension}`;
}
